import {EntityResourceIds} from '@dms/api/shared';

interface CustomNoticeTagSource {
  resourceId: EntityResourceIds;
  recordId: string;
}

export function buildCustomNoticeTag(source: CustomNoticeTagSource) {
  return {type: 'CustomNotice', id: `${source.resourceId}-${source.recordId}`} as const;
}
